import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import styled from '@emotion/styled';

import PageHeader from '../../../components/Layout/PageHeader';
import PageLayout from '../../../components/Layout/PageLayout';
import useDeviceWidth from '../../../hooks/ui-control/useDeviceWidth';
import SettingNavBoxItem from '../../../layout/Dashboard/sideNav/SettingNav';
import { SETTINGS } from '../../../routes/routeConstants';

const SETTINGS_ROOT = `/${SETTINGS}`;

const Settings = () => {
  const location = useLocation();
  const width = useDeviceWidth();

  const isDesktop = width > 884;
  const isAtRoot =
    location.pathname === SETTINGS_ROOT ||
    location.pathname === `${SETTINGS_ROOT}/`;

  if (isDesktop && isAtRoot) {
    return <Navigate to='profile' replace />;
  }

  return (
    <PageLayout>
      <Container>
        <PageHeader title='Settings' />

        <MainContentWeb>
          <SettingNavBoxItem />
          <Content>{isDesktop && <Outlet />}</Content>
        </MainContentWeb>

        <MainContentMobile>
          {isAtRoot ? (
            <SettingNavBoxItem />
          ) : (
            <MobileContent>
              <Content>{!isDesktop && <Outlet />}</Content>
            </MobileContent>
          )}
        </MainContentMobile>
      </Container>
    </PageLayout>
  );
};

export default Settings;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 80vh;
`;

const MainContentWeb = styled.div`
  display: grid;
  grid-template-columns: 258px 1fr;
  flex-direction: column;
  padding-top: 20px;

  @media (max-width: 884px) {
    display: none;
  }
`;

const MainContentMobile = styled.div`
  display: none;

  @media (max-width: 884px) {
    display: flex;
    margin-top: 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;

  @media (max-width: 884px) {
    padding: 0px;
  }
`;

const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
